<button
  type="button"
  class="locale-toggle"
  (click)="openLocaleModal()"
  [attr.aria-label]="select_text"
  data-automation="open-locale-modal"
>
  <i class="flag-icon flag-icon-{{ current_flag }}"></i>
</button>
